import { DateTime } from "luxon";

/**
 * 
 * @param {*} dateInput, checks if date is either object or string and transforms it
 * @returns { 'DateTime' } Luxon DateTime Object
 */
export const luxonParseDate = (dateInput) => {

    let date = null;

    /**
     * converting the received date time in specified format to luxon date time object
     */
    try {
        if(typeof dateInput == 'object') {
            date = DateTime.fromJSDate(dateInput);

        }
        if(typeof dateInput == 'string') {
            date = DateTime.fromISO(dateInput);
        }
    } catch (error) {
        console.log('transformdate.js error on convert from string or object: ' , error);
    }

        return date;

};

export default {luxonParseDate};